import { withRouter } from 'react-router';

import ScrollToTopOnMount from './ScrollToTopOnMount';

export default withRouter(ScrollToTopOnMount);
